import { sendWebsocketMessage } from "../../../../../../App";

export function removeSavedTradePlanConfig({ key, configName }) {
    const message = {
        messageType: "removeSavedTradePlanConfiguration",
        configurationName: configName,
        key: key,
    };
    // let message = JSON.stringify(messageObject);
    // console.log("removing stored tradeplan config: " + message);
    sendWebsocketMessage(message);
}
